Namespace 'Common.Dashboard'

class Common.Dashboard.AppliedFiltersHeader extends Backbone.View
  template: JST['backbone/templates/common/dashboard/navbar/applied_filters_header']
  className: 'applied-filters-header'

  events:
    'click .hide-filters': '_hideFilters'

  render: ->
    @$el.html @template({
      translations: {appliedFilters: I18n.t('common.navbar.menu.applied_filters')}
    })
    @

  _hideFilters: ->
    @trigger('filters:hide')
